import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';

import { Title } from 'components';
import { QCHECK } from '../texts'
import { Divider, TableContainer } from '@mui/material';
import QuestionGrid from './QuestionGrid'


const Section4 = ({ data, handleChange, count }) => {

  const theme = useTheme();

  const STYLES = {
    "griddy": {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      }
    },
  }

  return <>
    <Box display="flex" justifyContent="center" sx={{ pb: 1 }}>
      <Title text="KYC document checkList" color={ theme.palette.primary.main } />
    </Box>
    <Divider />
    <Box sx={{ m: 5, display: "flex", justifyContent: "center" }}>
      <Box sx={{ width: "70%" }}>
          <Grid container spacing={2}>
            {QCHECK.map((question, index) => (
              <Grid item xs={12} key={`${index}`}>
                <QuestionGrid
                  data={data}
                  question={question}
                  qNo='QCHECK'
                  index={index}
                  handleChange={handleChange}
                />
              </Grid>
            ))}
          </Grid>
      </Box>
    </Box>   
  </>
}

export default Section4;